import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlus as faPlusLight } from '@fortawesome/pro-light-svg-icons';
import {} from '@fortawesome/pro-solid-svg-icons';
import {
  faListAlt,
  faUserCircle,
  faMap,
  faEye,
  faDoNotEnter,
  faCaretCircleRight,
  faExclamationCircle,
  faCheckCircle,
  faSpinnerThird,
  faExclamationTriangle,
  faTimes,
  faChevronUp,
  faAlignLeft,
  faChevronDown,
  faArrowRight,
  faPen,
  faPlus,
  faFileExcel,
  faEllipsisH,
  faTable,
  faBold,
  faItalic,
  faStrikethrough,
  faUnderline,
  faListUl,
  faListOl,
  faQuestionCircle,
  faUndo,
  faHistory,
  faRedo,
  faPhotoVideo,
  faSearch,
  faHashtag,
  faBell,
  faTrash,
  faTools,
  faChevronLeft,
  faChevronRight,
  faUnlock,
  faDownload,
  faFileExport,
  faUpload,
} from '@fortawesome/pro-duotone-svg-icons';

const iconLibrary = () =>
  library.add(
    faUserCircle,
    faTimes,
    faBell,
    faAlignLeft,
    faTrash,
    faChevronLeft,
    faChevronRight,
    faChevronDown,
    faChevronUp,
    faArrowRight,
    faPen,
    faEye,
    faTools,
    faListAlt,
    faPlus,
    faFileExcel,
    faEllipsisH,
    faMap,
    faTable,
    faBold,
    faItalic,
    faStrikethrough,
    faUnderline,
    faListUl,
    faListOl,
    faDoNotEnter,
    faCaretCircleRight,
    faExclamationCircle,
    faQuestionCircle,
    faCheckCircle,
    faUndo,
    faSpinnerThird,
    faHistory,
    faRedo,
    faPhotoVideo,
    faSearch,
    faHashtag,
    faExclamationTriangle,
    faPlusLight,
    faUnlock,
    faDownload,
    faFileExport,
    faUpload,
  );

export default iconLibrary;
